
import actions from '../actions'
// src/reducers/chat-rooms-reducer.js

import {
  FETCH_CHAT_ROOMS,
  FETCH_CHAT_ROOMS_REQUESTED,
  FETCH_CHAT_ROOMS_COMPLETED,
  FETCH_CHAT_ROOMS_FAILED,
  CREATE_CHAT_ROOM,
  CREATE_CHAT_ROOM_REQUESTED,
  CREATE_CHAT_ROOM_COMPLETED,
  CREATE_CHAT_ROOM_FAILED,
  FETCH_CHAT_ROOM,
  FETCH_CHAT_ROOM_REQUESTED,
  FETCH_CHAT_ROOM_COMPLETED,
  FETCH_CHAT_ROOM_FAILED,
  FETCH_CHAT_ROOM_UNREAD_COUNT,
  FETCH_CHAT_ROOM_UNREAD_COUNT_REQUESTED,
  FETCH_CHAT_ROOM_UNREAD_COUNT_COMPLETED,
  FETCH_CHAT_ROOM_UNREAD_COUNT_FAILED,
  CLEAR_CHAT_ROOM_UNREAD_COUNT,
  DELETE_CHAT_ROOM,
  DELETE_CHAT_ROOM_REQUESTED,
  DELETE_CHAT_ROOM_COMPLETED,
  DELETE_CHAT_ROOM_FAILED,
  JOIN_CHAT_ROOM,
  JOIN_CHAT_ROOM_REQUESTED,
  JOIN_CHAT_ROOM_COMPLETED,
  JOIN_CHAT_ROOM_FAILED,
  LEAVE_CHAT_ROOM,
  LEAVE_CHAT_ROOM_REQUESTED,
  LEAVE_CHAT_ROOM_COMPLETED,
  LEAVE_CHAT_ROOM_FAILED,
  UPDATE_CHAT_ROOM,
  UPDATE_CHAT_ROOM_REQUESTED,
  UPDATE_CHAT_ROOM_COMPLETED,
  UPDATE_CHAT_ROOM_FAILED,
  FETCH_CHAT_ROOMS_LENGTH,
  CLEAR_CHAT_ROOMS,
  EXCLUDE_CHAT_ROOM,
  EXCLUDE_CHAT_ROOM_REQUESTED,
  EXCLUDE_CHAT_ROOM_COMPLETED,
  EXCLUDE_CHAT_ROOM_FAILED,
  LOAD_CHAT_ROOM,
  LOAD_CHAT_ROOM_UNREAD_COUNT,
  FETCH_ALBUM_CHAT_IMAGE,
  FETCH_ALBUM_CHAT_IMAGE_REQUESTED,
  FETCH_ALBUM_CHAT_IMAGE_COMPLETED,
  FETCH_ALBUM_CHAT_IMAGE_FAILED,
  FETCH_ALBUM_CHAT_FILE,
  FETCH_ALBUM_CHAT_FILE_REQUESTED,
  FETCH_ALBUM_CHAT_FILE_COMPLETED,
  FETCH_ALBUM_CHAT_FILE_FAILED,
  FETCH_ALBUM_CHAT_VIDEO,
  FETCH_ALBUM_CHAT_VIDEO_REQUESTED,
  FETCH_ALBUM_CHAT_VIDEO_COMPLETED,
  FETCH_ALBUM_CHAT_VIDEO_FAILED,
  CLEAR_CHAT_ALBUM,
  FETCH_ALBUM_LENGTH,
  MAKE_CHAT_MESSAGE_READ,
  MAKE_CHAT_MESSAGE_READ_REQUESTED,
  MAKE_CHAT_MESSAGE_READ_COMPLETED,
  MAKE_CHAT_MESSAGE_READ_FAILED,
} from '../actions/chat-rooms'

import { mergeArray, deleteArray } from '../helpers/store'

const initialState = {
  isFetching: false,
  isFetchFailed: false,
  isRequesting: false,
  isRequestFailed: false,
  isCreating: false,
  isCreateFailed: false,
  items: undefined,
  imageItems: undefined,
  fileItems: undefined,
  videoItems: undefined,
  created: undefined,
  hasMoreImage: true,
  hasMoreFile: true,
  hasMoreVideo: true,
  hasMore: true,
  unreadCount: undefined,
}

export default function chatRoomsReducer(state = initialState, action = {}) {
  switch(action.type) {
  case FETCH_CHAT_ROOMS_REQUESTED:
  case FETCH_CHAT_ROOM_REQUESTED:
  case FETCH_CHAT_ROOM_UNREAD_COUNT_REQUESTED:
  case FETCH_ALBUM_CHAT_IMAGE_REQUESTED:
  case FETCH_ALBUM_CHAT_FILE_REQUESTED:
  case FETCH_ALBUM_CHAT_VIDEO_REQUESTED:
    return Object.assign({}, state, {
      isFetching: true,
      isFetchFailed: false,
    })

  case CREATE_CHAT_ROOM_REQUESTED:
    return Object.assign({}, state, {
      isCreating: true,
      isCreateFailed: false,
      created: undefined,
    })

  case MAKE_CHAT_MESSAGE_READ_REQUESTED:
  case DELETE_CHAT_ROOM_REQUESTED:
    return Object.assign({}, state, {
      isRequesting: true,
      isRequestFailed: false,
    })

  case DELETE_CHAT_ROOM_REQUESTED:
  case JOIN_CHAT_ROOM_REQUESTED:
  case LEAVE_CHAT_ROOM_REQUESTED:
  case UPDATE_CHAT_ROOM_REQUESTED:
  case EXCLUDE_CHAT_ROOM_REQUESTED:
    return Object.assign({}, state, {
      isRequesting: true,
    })

  case FETCH_CHAT_ROOMS_FAILED:
  case FETCH_CHAT_ROOM_FAILED:
  case FETCH_CHAT_ROOM_UNREAD_COUNT_FAILED:
  case FETCH_ALBUM_CHAT_IMAGE_FAILED:
  case FETCH_ALBUM_CHAT_FILE_FAILED:
  case FETCH_ALBUM_CHAT_VIDEO_FAILED:
    return Object.assign({}, state, {
      isFetching: false,
      isFetchFailed: true,
    })

  case CREATE_CHAT_ROOM_FAILED:
    return Object.assign({}, state, {
      isCreating: false,
      isCreateFailed: true,
    })

  case DELETE_CHAT_ROOM_FAILED:
    return Object.assign({}, state, {
      isRequesting: false,
      isRequestFailed: true,
    })


  case JOIN_CHAT_ROOM_FAILED:
  case LEAVE_CHAT_ROOM_FAILED:
  case UPDATE_CHAT_ROOM_FAILED:
  case EXCLUDE_CHAT_ROOM_FAILED:
  case MAKE_CHAT_MESSAGE_READ_FAILED:
    return Object.assign({}, state, {
      isRequesting: false,
    })

  case FETCH_CHAT_ROOMS_COMPLETED:
    return Object.assign({}, state, {
      isFetching: false,
      isFetchFailed: false,
      items: action.offset > 0 ? mergeArray('chat_room_id', state.items, action.results) : action.results,
      hasMore: action.results.length == FETCH_CHAT_ROOMS_LENGTH,
    })

  case FETCH_ALBUM_CHAT_IMAGE_COMPLETED:
    return Object.assign({}, state, {
      isFetching: false,
      isFetchFailed: false,
      imageItems: action.offset > 0 ? mergeArray('file_id', state.imageItems, action.results.files) : action.results.files,
      hasMoreImage: action.results.files.length == FETCH_ALBUM_LENGTH,
    })

  case FETCH_ALBUM_CHAT_FILE_COMPLETED:
    return Object.assign({}, state, {
      isFetching: false,
      isFetchFailed: false,
      fileItems: action.offset > 0 ? mergeArray('file_id', state.fileItems, action.results.files) : action.results.files,
      hasMoreFile: action.results.files.length == FETCH_ALBUM_LENGTH,
  })

  case FETCH_ALBUM_CHAT_VIDEO_COMPLETED:
    return Object.assign({}, state, {
      isFetching: false,
      isFetchFailed: false,
      videoItems: action.offset > 0 ? mergeArray('video_id', state.videoItems, action.results.files) : action.results.files,
      hasMoreVideo: action.results.files.length == FETCH_ALBUM_LENGTH,
  })

  case CLEAR_CHAT_ALBUM:
    return Object.assign({}, state, {
      imageItems: undefined,
      fileItems: undefined,
      videoItems: undefined,
    })

  case CREATE_CHAT_ROOM_COMPLETED:
    return Object.assign({}, state, {
      isCreating: false,
      created: action.results,
      items: mergeArray('chat_room_id', state.items, [action.results], 'replace_or_prepend')
    })

  case FETCH_CHAT_ROOM_COMPLETED:
    return Object.assign({}, state, {
      isFetching: false,
      isFetchFailed: false,
      items: mergeArray('chat_room_id', state.items, [action.results], 'replace_or_prepend')
    })

  case FETCH_CHAT_ROOM_UNREAD_COUNT_COMPLETED:
    return Object.assign({}, state, {
      unreadCount: action.results.unread_count,
    })

  case CLEAR_CHAT_ROOM_UNREAD_COUNT:
    return Object.assign({}, state, {
      unreadCount: undefined,
    })

  case LOAD_CHAT_ROOM_UNREAD_COUNT:
    if (state.unreadCount == action.unread_count)
      return state
    else
      return Object.assign({}, state, {
        unreadCount: action.unread_count,
      })

  case DELETE_CHAT_ROOM_COMPLETED:
    return Object.assign({}, state, {
      isRequesting: false,
      isRequestFailed: false,
      items: deleteArray('chat_room_id', state.items, action.results.chat_room_id)
    })

  case JOIN_CHAT_ROOM_COMPLETED:
    return Object.assign({}, state, {
      isRequesting: false,
      items: mergeArray('chat_room_id', state.items, [action.results], 'replace_or_prepend')
    })

  case LEAVE_CHAT_ROOM_COMPLETED:
    return Object.assign({}, state, {
      isRequesting: false,
      items: deleteArray('chat_room_id', state.items, action.results.chat_room_id)
    })

  case UPDATE_CHAT_ROOM_COMPLETED:
    const results = Object.assign({}, action.results, {
      icon_image: {
        url: action.results.icon_image.url + `?refresh=${Math.random()}`,
        thumb_url: action.results.icon_image.thumb_url + `?refresh=${Math.random()}`,
      }
    })
    return Object.assign({}, state, {
      isRequesting: false,
      items: mergeArray('chat_room_id', state.items, [action.results], 'replace_or_prepend')
    })

  case CLEAR_CHAT_ROOMS:
    return Object.assign({}, initialState, {
      unreadCount: state.unreadCount,
    })

  case EXCLUDE_CHAT_ROOM_COMPLETED:
    return Object.assign({}, state, {
      isRequesting: false,
      items: mergeArray('chat_room_id', state.items, [action.results], 'replace_or_prepend')
    })

  case LOAD_CHAT_ROOM:
    return Object.assign({}, state, {
        items: action.deleted &&
        deleteArray('chat_room_id', state.items, action.chat_room.chat_room_id) ||
        mergeArray('chat_room_id', state.items, [action.chat_room], 'replace_or_prepend')
    })
  case MAKE_CHAT_MESSAGE_READ_COMPLETED:
    return Object.assign({}, state, {
      unreadCount: action.results.unread_count,
      isRequesting: false,
    })
  default:
    return state
  }
}




// WEBPACK FOOTER //
// ./src/reducers/chat-rooms-reducer.js